import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/";
const API_PATH_CRM = ConstantList.API_EN_POINT_CRM + "/";

export const pagingElasticPatient = (searchObject) =>
  axios.post(API_PATH + "elastic-patient/search", searchObject);

export const pagingElasticPatientHistory = (searchObject) =>
  axios.post(API_PATH + "elastic-patient-history/search", searchObject);

export const elasticTreatmentPlanCardHistory = (searchObject) =>
  axios.post(
    API_PATH + "elastic-treatment-plan-card-history/search",
    searchObject
  );

export const elasticPatientServiceRegisterHistory = (searchObject) =>
  axios.post(
    API_PATH + "elastic-patient-service-register-history/search",
    searchObject
  );

export const elasticDrugOrderHistory = (searchObject) =>
  axios.post(API_PATH + "elastic-drug-order-history/search", searchObject);

export const elasticStaffRevenueHistory = (searchObject) =>
  axios.post(API_PATH + "elastic-staff-revenue-history/search", searchObject);

export const pagingElasticLeads = (searchObject) =>
  axios.post(API_PATH + "elastic-leads/elastic-paging", searchObject);
